import { Analytics, Apps, Auth, AuthLogin, CentralLogin, Companies, Configuration, Countries, Devices, Default, Downloads, Groups, Images, Licenses, LoginIdentities, Rooms, Sso, Tags, Terms, Uploads, Users, Webhooks, } from './openapi';
import { BaseApi } from './base_api';
import { invariant } from '@streem/toolbox';
class StreemAPI {
    configure({ apiUrl, tokenFetcher }, openApiConfig) {
        this.base = new BaseApi(apiUrl, tokenFetcher, openApiConfig);
    }
    setShareToken(token) {
        invariant(this.base, 'StreemAPI.configure must be called first');
        this.base.setShareToken(token);
    }
    setAdminBearerToken(token) {
        invariant(this.base, 'StreemAPI.configure must be called first');
        this.base.setAdminBearerToken(token);
    }
    setApiKey(id, secret) {
        invariant(this.base, 'StreemAPI.configure must be called first');
        this.base.setApiKey(id, secret);
    }
    get configuration() {
        invariant(this.base, 'StreemAPI.configure must be called first');
        return new Configuration(this.base.apiConfig);
    }
    get analytics() {
        invariant(this.base, 'StreemAPI.configure must be called first');
        const analyticsApiConfig = {
            ...this.base.apiConfig,
            middleware: [
                ...(this.base.apiConfig.middleware ?? []),
                // Mark all analytics requests as keepalive (send even after page is closed)
                {
                    pre: async (event) => {
                        event.init.keepalive = true;
                        return event;
                    },
                },
            ],
        };
        const analyticsConfig = new Configuration(analyticsApiConfig);
        return new Analytics.AnalyticsApi(analyticsConfig);
    }
    get apps() {
        invariant(this.base, 'StreemAPI.configure must be called first');
        return new Apps.AppsApi(this.configuration);
    }
    get auth() {
        invariant(this.base, 'StreemAPI.configure must be called first');
        return new Auth.AuthApi(this.configuration);
    }
    get authLogin() {
        invariant(this.base, 'StreemAPI.configure must be called first');
        return new AuthLogin.AuthLoginApi(this.configuration);
    }
    get centralLogin() {
        invariant(this.base, 'StreemAPI.configure must be called first');
        return new CentralLogin.CentralLoginApi(this.configuration);
    }
    get companies() {
        invariant(this.base, 'StreemAPI.configure must be called first');
        return new Companies.CompaniesApi(this.configuration);
    }
    get countries() {
        invariant(this.base, 'StreemAPI.configure must be called first');
        return new Countries.CountriesApi(this.configuration);
    }
    get downloads() {
        invariant(this.base, 'StreemAPI.configure must be called first');
        return new Downloads.DownloadsApi(this.configuration);
    }
    get default() {
        invariant(this.base, 'StreemAPI.configure must be called first');
        return new Default.DefaultApi(this.configuration);
    }
    get devices() {
        invariant(this.base, 'StreemAPI.configure must be called first');
        return new Devices.DevicesApi(this.configuration);
    }
    get groups() {
        invariant(this.base, 'StreemAPI.configure must be called first');
        return new Groups.GroupsApi(this.configuration);
    }
    get images() {
        invariant(this.base, 'StreemAPI.configure must be called first');
        return new Images.ImagesApi(this.configuration);
    }
    get licenses() {
        invariant(this.base, 'StreemAPI.configure must be called first');
        return new Licenses.LicensesApi(this.configuration);
    }
    get rooms() {
        invariant(this.base, 'StreemAPI.configure must be called first');
        return new Rooms.RoomsApi(this.configuration);
    }
    get sso() {
        invariant(this.base, 'StreemAPI.configure must be called first');
        return new Sso.SsoApi(this.configuration);
    }
    get loginIdentities() {
        invariant(this.base, 'StreemAPI.configure must be called first');
        return new LoginIdentities.LoginIdentitiesApi(this.configuration);
    }
    get uploads() {
        invariant(this.base, 'StreemAPI.configure must be called first');
        return new Uploads.UploadsApi(this.configuration);
    }
    get users() {
        invariant(this.base, 'StreemAPI.configure must be called first');
        return new Users.UsersApi(this.configuration);
    }
    get tags() {
        invariant(this.base, 'StreemAPI.configure must be called first');
        return new Tags.TagsApi(this.configuration);
    }
    get terms() {
        invariant(this.base, 'StreemAPI.configure must be called first');
        return new Terms.TermsApi(this.configuration);
    }
    get webhooks() {
        invariant(this.base, 'StreemAPI.configure must be called first');
        return new Webhooks.WebhooksApi(this.configuration);
    }
}
// This is a singleton, default export is valid here.
// eslint-disable-next-line import/no-default-export
export default new StreemAPI();
//# sourceMappingURL=streem_api.js.map